module.exports = __webpack_public_path__ + "static/img/chenggong.db672b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/buy/chenggong.png
// module id = W0Ax
// module chunks = 1